module.exports = __webpack_public_path__ + "images/saaremaa/apple-icon-precomposed.png";